// frontend/src/hooks/useMatchMedia.ts
// React hook for CSS media queries -> boolean, with SSR-safe fallback.
import { useEffect, useState } from 'react';

export function useMatchMedia(query: string): boolean {
  const [match, setMatch] = useState(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return false;
    return window.matchMedia(query).matches;
  });

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return;
    const mql = window.matchMedia(query);
    const handler = (ev: MediaQueryListEvent) => setMatch(ev.matches);
    setMatch(mql.matches);
    if (mql.addEventListener) mql.addEventListener('change', handler);
    else mql.addListener(handler);
    return () => {
      if (mql.removeEventListener) mql.removeEventListener('change', handler);
      else mql.removeListener(handler);
    };
  }, [query]);

  return match;
}
